export function LiveIndicator({ size = 8 }: { size?: number }) {
  return <span className="live-dot" style={{ width: size, height: size }} />;
}

export function StatusBadge({ status }: { status: 'scheduled' | 'in_progress' | 'completed' | 'not_started' }) {
  const config: Record<string, { label: string; className: string }> = {
    scheduled: { label: 'Nezačal', className: 'badge badge-scheduled' },
    not_started: { label: 'Nezačal', className: 'badge badge-scheduled' },
    in_progress: { label: '● LIVE', className: 'badge badge-live' },
    completed: { label: '✓ Hotovo', className: 'badge badge-completed' },
  };
  const { label, className } = config[status] ?? config.scheduled;
  return <span className={className}>{label}</span>;
}
